import { render, staticRenderFns } from "./TransactionError.vue?vue&type=template&id=5d684ba0&scoped=true"
import script from "./TransactionError.vue?vue&type=script&lang=js"
export * from "./TransactionError.vue?vue&type=script&lang=js"
import style0 from "./TransactionError.vue?vue&type=style&index=0&id=5d684ba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d684ba0",
  null
  
)

export default component.exports